<template>
    <nav class="bohemia-header-nav-center">
        <ul class="bohemia-header-nav-items">
            <li class="bohemia-header-nav-item" v-for="(item, key) in items"
                :class="{dropdown : item.dropdown, active : (active === item.id)}">

                <Dropdown v-if="item.dropdown" :items="item.dropdown" :id="key" :openItem="open" @onOpen="onOpen">
                    <template slot-scope="props">
                        <a class="bohemia-header-nav-item-button"
                           @click="props.onClick"
                           :class="{open : props.open}"
                           href="javascript:void(0)"
                           data-active="false" :data-id="key">
                            <span>{{item.name}}</span>
                            <svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"/></svg>
                        </a>
                    </template>
                </Dropdown>

                <a v-else=""
                   class="bohemia-header-nav-item-button"
                   :href="item.href">
                    <span>{{item.name}}</span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
    import Dropdown from '../partials/Dropdown';

    export default {
        name: 'navigation',
        components: {
            Dropdown
        },
        props: {
            items: Array,
            active: {},
            open: {}
        },
        methods: {
            onOpen(id) {
                this.$emit('onOpen', id)
            },
            setActiveNavItem () {
                let url = window.location.href.toLowerCase();

                if (url.slice(-1) === '/') {
                    url = url.slice(0, -1);
                }

                let elements = document.querySelectorAll(`a[href="${url}"]`);
                elements = Array.prototype.slice.call(elements);

                elements.forEach(el => {
                    el.dataset.active = true;

                    if(el.dataset.parentId) {
                        document.querySelector(`[data-id="${el.dataset.parentId}"]`).dataset.active = true;
                    }
                });
            },
        },
        mounted() {
            if (!this.active) {
                this.setActiveNavItem()
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../assets/scss/header/colors';
    @import '../../../assets/scss/header/nav';
    @import '../../../assets/scss/header/vars';
    @import '../../../assets/scss/breakpoints';

    .bohemia-header-nav-center {

        @media (max-width: $brMedium) {
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 100%;
            background: transparent;
            visibility: hidden;
            opacity: 0;
            z-index: -10;

            .bohemia-header-nav-items {
                width: 100%;
                max-width: 100%;
                display: flex;
                flex-direction: column;
                transition: all .5s;

                .bohemia-header-nav-item {
                    background: rgba(0, 0, 0, .7);
                }

                .bohemia-header-nav-item-button {
                    text-align: left;
                }
            }

            &.open {
                visibility: visible;
                opacity: 1;
                z-index: 100;
                transition: all .5s;
            }
        }
    }

    .bohemia-header-nav-item-button {
        svg {
            width: 1em;
            height: 1em;
            fill: currentColor;
            vertical-align: middle;
        }
    }

</style>